import { Component, Input } from '@angular/core';
import { DID_CLASS } from 'voxloud-types/dist/models/dids/dids.model';

import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { CompanyService } from 'src/app/domains/companies/services';
import { Company, CONTROL_PANEL_ENVIRONMENT } from 'src/app/domains/companies/models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WipLoginPopupComponent } from '../wip-login-popup/wip-login-popup.component';

@Component({
  selector: 'gdp-companies-table',
  templateUrl: './companies-table.component.html',
  styleUrls: ['./companies-table.component.scss']
})
export class CompaniesTableComponent {
  @Input() companies: Company[];
  @Input() loading: boolean;
  public ENV = CONTROL_PANEL_ENVIRONMENT;
  public DID_ICON_CLASS = {
    [DID_CLASS.VOICE]: 'icon-small-telephone',
    [DID_CLASS.FAX]: 'icon-small-fax'
  };
  public canWipLogin = !environment.production;

  constructor(
    private notification: NotificationService,
    private companyService: CompanyService,
    private modalService: NgbModal
  ){}

  openControlPanel(
    company: Company,
    env: CONTROL_PANEL_ENVIRONMENT
  ): void {
    this.companyService.openControlPanel(company, env);
  }

  deleteCompany(c:Company) {
    this.notification.showConfirmation('companies.confirm-delete').then((result: string) => {
      if (result === 'ok') {
        c.deleting = true;
        this.companyService.deleteCompany(c).subscribe(() => {
          delete c.deleting;
          this.companies = this.companies.filter(comp => comp.companyId !== c.companyId);
        });
      }
    });
  }

  lockCompany(c: Company) {
    this.notification.showConfirmationWithAlphaname(
      'companies.confirm-lock',
      c.alphaname
    ).then((result: string) => {
      if (result === 'ok') {
        c.locking = true;
        this.companyService.lockCompany(c).subscribe(() => {
          c.locked = true;
          delete c.locking;
          this.notification.success('companies.table.company-locked')
        });
      }
    });
  }

  unlockCompany(c: Company) {
    this.notification.showConfirmationWithAlphaname(
      'companies.confirm-unlock',
      c.alphaname
    ).then((result: string) => {
      if (result === 'ok') {
        c.unlocking = true;
        this.companyService.unlockCompany(c).subscribe(() => {
          c.locked = false;
          delete c.unlocking;
          this.notification.success('companies.table.company-unlocked')
        });
      }
    });
  }

  openWipLoginPopup(c: Company) {
    const m = this.modalService.open(WipLoginPopupComponent);
    m.componentInstance.company = c;
  }

  isDisabledLock(c: Company) {
    return environment.idsCompanyDisableLock.includes(c.companyId);
  }

}
